import Vue from 'vue';
// 在main.js或单独指令文件中
Vue.directive('num', {
  bind(el) {
    el.handleInput = function (e) {
      let value = e.target.value
      // 保留数字和允许的小数点
      value = value.replace(/[^\d.]/g, '')
      // 去除多余的小数点（只保留第一个）
      const splitArr = value.split('.')
      if (splitArr.length > 2) {
        value = `${splitArr[0]}.${splitArr.slice(1).join('')}`
      }
      // 禁止以小数点开头
      if (value.startsWith('.')) {
        value = value.replace('.', '')
      }
      // 更新值并触发输入事件
      if (e.target.value !== value) {
        e.target.value = value
        e.target.dispatchEvent(new Event('input'))
      }
    }

    el.handlePaste = function (e) {
      const clipboardData = e.clipboardData || window.clipboardData
      const text = clipboardData.getData('text')
      if (!/^\d*\.?\d*$/.test(text)) {
        e.preventDefault()
      }
    }

    el.addEventListener('input', el.handleInput)
    el.addEventListener('paste', el.handlePaste)
  },
  unbind(el) {
    el.removeEventListener('input', el.handleInput)
    el.removeEventListener('paste', el.handlePaste)
  }
})